<button fxLayout="row" fxLayoutAlign="start center" class="w-100-p" mat-menu-item (click)="onClickButton($event)" [disabled]="disabled">
    <mat-icon class="mr-8" *ngIf="icon">{{ icon }}</mat-icon>
    <mat-icon class="mr-8" *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>

    <span class="text-sm text-wrap">{{ label | translate }}<span *ngIf="showThreeDots">...</span></span>
</button>
